"use client";

import { Compass, Menu, Upload } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { useState } from "react";

import { LocaleSwitcher } from "@/components/locale-switcher";
import { ThemeToggle } from "@/components/theme-toggle";
import { Link, usePathname } from "@/i18n/navigation";

export function TopbarMenu() {
  const t = useTranslations("Layout");
  const locale = useLocale();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-label={t("menu")}
        className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-zinc-300 bg-zinc-100/90 text-zinc-700 transition hover:border-zinc-400 dark:border-zinc-700 dark:bg-zinc-900/80 dark:text-zinc-200 dark:hover:border-zinc-500"
      >
        <Menu className="h-4 w-4" />
      </button>

      {isOpen ? (
        <div className="absolute right-0 top-11 z-30 w-60 rounded-2xl border border-zinc-300 bg-white/95 p-3 shadow-[0_18px_60px_rgba(0,0,0,0.18)] backdrop-blur dark:border-zinc-800 dark:bg-zinc-950/95 dark:shadow-[0_18px_60px_rgba(0,0,0,0.45)]">
          <div className="grid gap-1">
            <Link
              href="/"
              locale={locale}
              onClick={() => setIsOpen(false)}
              className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition ${
                pathname === "/"
                  ? "bg-zinc-200 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100"
                  : "text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-900 dark:hover:text-zinc-100"
              }`}
            >
              <Compass className="h-3.5 w-3.5" />
              {t("discover")}
            </Link>
            <Link
              href="/submit"
              locale={locale}
              onClick={() => setIsOpen(false)}
              className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition ${
                pathname === "/submit"
                  ? "bg-zinc-200 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100"
                  : "text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-900 dark:hover:text-zinc-100"
              }`}
            >
              <Upload className="h-3.5 w-3.5" />
              {t("submit")}
            </Link>
          </div>

          <div className="my-3 h-px bg-zinc-200 dark:bg-zinc-800" />

          <div className="flex items-center justify-between gap-2">
            <LocaleSwitcher />
            <ThemeToggle />
          </div>
        </div>
      ) : null}
    </div>
  );
}
